import { Component, Input, OnInit } from '@angular/core';
import { LivreurUberService } from '../livreur-uber.service';

@Component({
  selector: 'app-panier',
  templateUrl: './panier.component.html',
  styleUrls: ['./panier.component.css']
})
export class PanierComponent implements OnInit {
   @Input() lePanier;
  

   

  
  enleverDuPanier(quelGateau:Object){
    let indexDuGateauASupprimerDuPanier =this.lePanier.indexOf(quelGateau)
    this.lePanier.splice(indexDuGateauASupprimerDuPanier,1)

  };
  
  calculDuTotal(){
    let total = 0;
    this.lePanier.forEach(chaqueGateau => {
     
     total +=chaqueGateau.prix;
      
    });
    return total;
  


  };
  nombreProduits =51;

  constructor(private monService : LivreurUberService) { }

  ngOnInit(): void {
    this.lePanier = this.monService.livrerLacommande();
    
    
  }
  
    

}
